import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import About from './pages/About';
import ServicesPage from './pages/Services';
import GalleryPage from './pages/GalleryPage';
import FeaturesPage from './pages/FeaturesPage';
import HowItWorksPage from './pages/HowItWorksPage';
import BusinessPage from './pages/BusinessPage';
import TestimonialsPage from './pages/TestimonialsPage';
import PlansPage from './pages/PlansPage';
import RequestPage from './pages/RequestPage';
import ContactPage from './pages/ContactPage';
import './styles/global.css';
import './styles/components.css';
import { LanguageProvider } from './i18n/I18nContext';
import SeoAnalytics from './components/analytics/SeoAnalytics';

const App: React.FC = () => (
  <LanguageProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <SeoAnalytics />
      <MainLayout>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/request" element={<RequestPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<Home />} />
        </Routes>
      </MainLayout>
    </BrowserRouter>
  </LanguageProvider>
);

export default App;
